/*
  ATENAS STORE · Carrito lateral (drawer) + agregar al carrito por AJAX
  ---------------------------------------------------------------------
  Lo usan los dos formatos (KICKS y HEEPZY). Funciona con atributos data-*:

  - <form data-atn-add> o class="atn-add-form" → agrega al carrito sin recargar
  - [data-atn-cart-open]           → abre el carrito lateral
  - [data-atn-cart-close]          → cierra el carrito lateral
  - [data-atn-count]               → muestra la cantidad de productos
  - [data-atn-line-qty]            → botones +/- dentro del carrito (data-key, data-qty)
  - [data-atn-quick-add]           → botón que agrega una variante directa (data-variant-id)

  El contenido del carrito lo dibuja la sección "atenas-cart-drawer.liquid",
  así que los textos y colores se editan desde el editor de temas.
*/
(function () {
  if (window.AtenasCart) return;

  var SECTION_ID = 'atenas-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerWrap() { return document.getElementById('shopify-section-' + SECTION_ID); }
  function drawer() { return document.querySelector('[data-atn-drawer]'); }

  function setCount(count) {
    document.querySelectorAll('[data-atn-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', !count);
    });
  }

  function renderSection(html) {
    if (!html) return;
    var wrap = drawerWrap();
    if (!wrap) return;
    var wasOpen = drawer() && drawer().classList.contains('is-open');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-atn-drawer]');
    var current = drawer();
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
  }

  function open() {
    var d = drawer();
    if (!d) { window.location.href = root + 'cart'; return; }
    if (d.classList.contains('atn-drawer--page')) { d.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('atn-lock');
    var close = d.querySelector('[data-atn-cart-close]');
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 50);
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('atn-lock');
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function add(items, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return post('cart/add.js', { items: items, sections: SECTION_ID, sections_url: window.location.pathname })
      .then(function (res) {
        if (res.sections) renderSection(res.sections[SECTION_ID]);
        return refreshCount();
      })
      .then(function () {
        open();
        document.dispatchEvent(new CustomEvent('atenas:cart:added', { detail: { items: items } }));
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'No pudimos agregar el producto. Intenta de nuevo.';
        showError(button, msg);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  }

  function change(key, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    return post('cart/change.js', { id: key, quantity: quantity, sections: SECTION_ID, sections_url: window.location.pathname })
      .then(function (res) {
        if (res.sections) renderSection(res.sections[SECTION_ID]);
        setCount(res.item_count);
      })
      .catch(function (err) {
        alert((err && err.description) || 'No pudimos actualizar el carrito.');
      })
      .finally(function () { if (drawer()) drawer().classList.remove('is-busy'); });
  }

  function showError(button, msg) {
    var scope = button && button.closest('form, [data-atn-card]');
    var box = scope && scope.querySelector('[data-atn-error]');
    if (box) {
      box.textContent = msg;
      box.hidden = false;
      setTimeout(function () { box.hidden = true; }, 5000);
    } else {
      alert(msg);
    }
  }

  // ---- Eventos ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-atn-add], form.atn-add-form');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return;
    var item = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    });
    if (Object.keys(props).length) item.properties = props;
    add([item], form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-atn-cart-open]'))) { e.preventDefault(); open(); return; }
    if ((t = e.target.closest('[data-atn-cart-close]'))) { e.preventDefault(); close(); return; }
    if ((t = e.target.closest('[data-atn-line-qty]'))) {
      e.preventDefault();
      change(t.dataset.key, Number(t.dataset.qty));
      return;
    }
    if ((t = e.target.closest('[data-atn-quick-add]'))) {
      e.preventDefault();
      add([{ id: Number(t.dataset.variantId), quantity: 1 }], t);
    }
  });

  // Upsell del carrito: el selector de talla/opción cambia la variante del botón
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-atn-up-select]');
    if (!sel) return;
    var btn = sel.parentNode.querySelector('[data-atn-quick-add]');
    if (btn) btn.dataset.variantId = sel.value;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Vuelve a dibujar el carrito con lo que haya en Shopify (lo usa el reemplazo del carrito de Gecko)
  function refresh() {
    return fetch(root + '?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderSection(data[SECTION_ID]); return refreshCount(); });
  }

  // Un solo carrito: si el tema base (Gecko) intenta abrir su carrito lateral
  // (landings, vista rápida…), se cierra y se abre el carrito Atenas.
  (function replaceGeckoCart() {
    var gk = document.getElementById('t4s-mini_cart');
    if (!gk || !drawer()) return;
    var st = document.createElement('style');
    st.textContent = '#t4s-mini_cart{display:none!important}';
    document.head.appendChild(st);
    new MutationObserver(function () {
      if (gk.getAttribute('aria-hidden') !== 'false') return;
      var x = gk.querySelector('[data-drawer-close]');
      if (x) x.click();
      gk.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('t4s-lock-scroll', 'is--opend-drawer');
      refresh().then(open);
    }).observe(gk, { attributes: true, attributeFilter: ['aria-hidden'] });
  })();

  // Página /cart: el mismo carrito se muestra dentro de la página
  (function cartPage() {
    var slot = document.querySelector('[data-atn-cart-page]');
    var d = drawer();
    if (!slot || !d) return;
    d.classList.add('atn-drawer--page');
    d.setAttribute('aria-hidden', 'false');
    slot.appendChild(d);
  })();

  window.AtenasCart = { open: open, close: close, add: add, change: change, refresh: refresh, refreshCount: refreshCount };
})();
